import styles from "./LineSeparator.module.scss";
import * as React from "react";

export const LineSeparator = () => {
    return <div className={styles["line-separator"]} />;
}